import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faChartLine,
  faBook,
  faBookmark,
  faStickyNote,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import UserContext from "../../contexts/UserContext";
import StudyDashboard from "./components/StudyDashboard";
import SubjectManager from "./components/SubjectManager";
import SourceManager from "./components/SourceManager";
import NoteManager from "./components/NoteManager";
import StudyLogManager from "./components/StudyLogManager";
import SubjectDetail from "./components/SubjectDetail";
import "./StudyHub.css";

const StudyHub = () => {
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);

  const handleViewSubject = (subjectId) => {
    setSelectedSubjectId(subjectId);
    setActiveTab("subjectDetail");
  };

  const handleBackFromDetail = () => {
    setSelectedSubjectId(null);
    setActiveTab("subjects");
  };

  const isAdmin = () => {
    return user && (user.role === "admin" || user.AdminAccess === 1);
  };

  if (!isAdmin()) {
    return (
      <div className="studyhub-access-denied">
        <div className="access-denied-card">
          <FontAwesomeIcon icon={faGraduationCap} className="denied-icon" />
          <h2>Access Restricted</h2>
          <p>Admin privileges required to access Study Hub</p>
        </div>
      </div>
    );
  }

  return (
    <div className="studyhub-container">
      {/* Header */}
      <div className="studyhub-header">
        <div className="header-content">
          <FontAwesomeIcon icon={faGraduationCap} className="header-icon" />
          <div className="header-text">
            <h1>Study Hub</h1>
            <p>
              Track your learning journey, organize notes, and monitor progress
            </p>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="studyhub-tabs">
        <button
          className={`stab-btn ${activeTab === "dashboard" ? "active" : ""}`}
          onClick={() => setActiveTab("dashboard")}
        >
          <FontAwesomeIcon icon={faChartLine} />
          <span>Dashboard</span>
        </button>
        <button
          className={`stab-btn ${activeTab === "subjects" ? "active" : ""}`}
          onClick={() => setActiveTab("subjects")}
        >
          <FontAwesomeIcon icon={faBook} />
          <span>Subjects</span>
        </button>
        <button
          className={`stab-btn ${activeTab === "sources" ? "active" : ""}`}
          onClick={() => setActiveTab("sources")}
        >
          <FontAwesomeIcon icon={faBookmark} />
          <span>Sources</span>
        </button>
        <button
          className={`stab-btn ${activeTab === "notes" ? "active" : ""}`}
          onClick={() => setActiveTab("notes")}
        >
          <FontAwesomeIcon icon={faStickyNote} />
          <span>Notes</span>
        </button>
        <button
          className={`stab-btn ${activeTab === "studylog" ? "active" : ""}`}
          onClick={() => setActiveTab("studylog")}
        >
          <FontAwesomeIcon icon={faClockRotateLeft} />
          <span>Study Log</span>
        </button>
      </div>

      {/* Content Area */}
      <div className="studyhub-content">
        {activeTab === "dashboard" && (
          <StudyDashboard onViewSubject={handleViewSubject} />
        )}
        {activeTab === "subjects" && (
          <SubjectManager onViewSubject={handleViewSubject} />
        )}
        {activeTab === "sources" && <SourceManager />}
        {activeTab === "notes" && <NoteManager />}
        {activeTab === "studylog" && <StudyLogManager />}
        {activeTab === "subjectDetail" && selectedSubjectId && (
          <SubjectDetail
            subjectId={selectedSubjectId}
            onBack={handleBackFromDetail}
          />
        )}
      </div>
    </div>
  );
};

export default StudyHub;
